import { z } from 'zod';

export const formSchema = z.object({
  productReasonTypeId: z.string({ required_error: 'Selecione o motivo' }),
});

export type FormSchema = z.infer<typeof formSchema>;